import { jsx as _jsx } from "react/jsx-runtime";
import { Icon, UnstyledButton } from '@ui/ford-ui-components';
import { useModalDispatch } from '../modal-system';
export const ModalCloseButton = () => {
    const { closeModal } = useModalDispatch();
    return (_jsx(UnstyledButton, { onClick: () => closeModal(), className: "mb-auto ml-4 p-2 hover:bg-ford-fill-subtle rounded-ford-radius-sm", "aria-label": "Close", children: _jsx(Icon, { height: "16", width: "16", name: "close" }) }));
};
